import React from 'react';
import Box from '@mui/material/Box';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Accordions from '../components/Accordions/Accordions';
import ProductGallery from '../components/product/ProductGallery';
import TextBtnSection from '../components/Section/TextBtnSection';
import ContentCard from '../components/Cards/ContentCard';
import ProgressCarousel from '../components/Carousel/ProgressCarousel';
import { useTranslation } from '../hook/Translation';



export default function ManicureAndPedicure() {
    const { t } = useTranslation();
    const accodirons = [
        {
            title: 'Technology and products',
            content: 'We use disposable liners, fully sterilized tools and Glossify professional formulas. Gel polish can be LED cured for long wear and no dry time.'
        },
        {
            title: 'Treatment areas',
            content: 'Hands to the elbow. Feet to the calf. Both include massage and moisture for comfort.'
        },
    ]

    const products = [
        {
            imageUrl: '/images/product_1.png',
            shop: true,
            type: 'Skin Cushion',
            reviews: '5',
            reviewAmount: '45',
            name: 'Pro Lipid Recovery Cream 30ml',
            price: '120',
        },
        {
            imageUrl: '/images/blank-white-cosmetic-tube-mockup-perfect-skincare-beauty-product-presentation.png',
            shop: false,
            type: 'Skin Cushion',
            reviews: '4',
            reviewAmount: '20',
            name: 'Pro Lipid Recovery Cream 100ml',
            price: '150',
        },
    ];

    const OPTIONS = { dragFree: true }
    // const SLIDE_COUNT = 5
    const SLIDES = [
        {
            text: 'CLASSIC PEDICURE TREATMENT',
        },
        {
            text: 'CLASSIC PEDICURE + MANICURE',
        },
        {
            text: 'PEDICURE + GEL POLISH',
        },
        {
            text: 'GEL POLISH',
        },
    ];

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'#1E353D'}>
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection
                    // titleSize={{ md: 8, xs: 12 }}
                    // descriptionSize={{}}
                    data={{
                        type: "Nail Bar",
                        title: "Manicure & Pedicure",
                        description: "Impeccably groomed nails and pure relaxation. Our Nail Bar services provide both aesthetic perfection for your nails and a dose of pampering for your hands and feet an essential finishing touch to your self-care routine.",
                        bookUrl: "/",
                        learn: ""
                    }}
                />
            </Box>
           
            <Box marginTop={{md: '118px', xs: '50px'}}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box marginTop={{md: '80px', xs: '50px'}}>
                <Typography variant="h3" color="text.secondary" textAlign={'center'} fontFamily={'DanmarkURW'} fontWeight={'bold'} fontSize={{md: '46px', xs: '2rem'}}>Menicure</Typography>
                <Box className="generalContainer" marginX={'auto'} gap={{md: '89px', xs: '40px'}} display={'flex'} flexDirection={'column'} mt={{md: '80px', xs: '50px'}}>
                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Extension-with-tip.png`,
                            title: 'Extension With Tips',
                            description: 'Lengthen your nails with lightweight, durable tips. Perfect shape, seamless finish, beautiful strength.',
                            direction: { md: 'row-reverse', xs: 'row' },
                            book: '/'
                        }}
                        containerStyle={{ alignItems: 'start', height: 'unset', gap: '50px' }}
                        contentHeight={'unset'} 
                        buttonHeight={'unset'}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Extension-with-tip.png`,
                            title: 'Natural Nails With Gel',
                            description: 'A glossy, long lasting gel layer over your natural nails. For shine, protection, and everyday elegance.',
                            book: '/'
                        }}
                        containerStyle={{ alignItems: 'start', height: 'unset', gap: '50px' }}
                        contentHeight={'unset'} 
                        buttonHeight={'unset'}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Extension-with-tip.png`,
                            title: 'Natural Nails With Mega Base',
                            description: 'Reinforces natural nails with a thicker, flexible base. Ideal for weak or thin nails needing extra support.',
                            direction: { md: 'row-reverse', xs: 'row' },
                            book: '/'
                        }}
                        containerStyle={{ alignItems: 'start', height: 'unset', gap: '50px' }}
                        contentHeight={'unset'} 
                        buttonHeight={'unset'}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                    <ContentCard
                        data={{
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Extension-with-tip.png`,
                            title: 'French Manicure',
                            description: 'The iconic pink and white finish in perfect symmetry. Chic, minimal, and effortlessly sophisticated.',
                            book: '/'
                        }}
                        containerStyle={{ alignItems: 'start', height: 'unset', gap: '50px' }}
                        contentHeight={'unset'} 
                        buttonHeight={'unset'}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />

                    <ContentCard
                        data={{
                            // imageUrl: 'https://signup.rinu.me/images/2025/12/Extension-with-tip.png',
                            title: 'Nail Extension With Gel',
                            description: 'Build length and structure using sculpted gel. Strong, natural looking, and fully customizable.',
                            direction: { md: 'row-reverse', xs: 'row' },
                            book: '/'
                        }}
                        containerStyle={{ alignItems: 'start', height: 'unset', gap: '50px' }}
                        contentHeight={'unset'} 
                        buttonHeight={'unset'}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                    <ContentCard
                        data={{
                            // imageUrl: 'https://signup.rinu.me/images/2025/12/Extension-with-tip.png',
                            title: 'Luxury Manicure',
                            description: 'A complete treatment with shaping, cuticle care, gel, and glow. Our most indulgent, polished, and flawless finish.',
                            book: '/'
                        }}
                        containerStyle={{ alignItems: 'start', height: 'unset', gap: '50px' }}
                        contentHeight={'unset'} 
                        buttonHeight={'unset'}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                    <ContentCard
                        data={{
                            // imageUrl: 'https://signup.rinu.me/images/2025/12/Extension-with-tip.png',
                            title: 'Nail Extension With Gel',
                            description: 'Build length and structure using sculpted gel. Strong, natural looking, and fully customizable.',
                            direction: { md: 'row-reverse', xs: 'row' },
                            book: '/'
                        }}
                        containerStyle={{ alignItems: 'start', height: 'unset', gap: '50px' }}
                        contentHeight={'unset'} 
                        buttonHeight={'unset'}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box>
            </Box>

            <Grid container position={'relative'} marginTop={{ md: '115px', xs: '50px' }} sx={{ marginLeft: 'auto', width: {lg: '80%', xs: '90%'} }} gap={{md: '80px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography variant="h4" color="text.secondary" width={{md: '90%', xs: '100%'}} mx={'auto'} fontWeight={'bold'} fontSize={{md: '66px', xs: '2rem'}} fontFamily={'DanmarkURW'}>Pedicure</Typography>
                </Grid>
                <Grid size={12}>
                    <ProgressCarousel slides={SLIDES} options={OPTIONS} buttonSize={{ lg: 6, md: 6, sm: 8, xs: 12 }} noUnderLine={true} textSize={{md: 12, xs: 12}} />
                </Grid>
            </Grid> 

            <Grid container gap={{md: '80px', xs: '30px'}} className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{md: '200px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={600} textAlign={'center'}>Additional Information</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            <Grid container gap={{md: '40px', xs: '22px'}} sx={{ marginX: 'auto' }} marginTop={{md: '101px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={600} textAlign={'center'}>Recomanded Products</Typography>
                </Grid>
                <Grid size={12}>
                    <Box>
                        <ProductGallery product={products} />
                    </Box>
                </Grid>
            </Grid>

            
        </Box>
    )
}